// extracted by mini-css-extract-plugin
module.exports = {"label":"FormGroup-m__label___G4laq"};